import slugify from 'slugify'

export const slugifyTitle = (title: string | undefined | null) =>
  title ? slugify(title, { lower: true }) : undefined
